<script>
import ConfigWindow from "./windows/configs.vue";
import GeneralWindow from "./windows/geral.vue";
import PlataformWindow from "./windows/plataformas.vue";
import WorkflowWindow from "./windows/workflow";
import { mapGetters } from "vuex";

const WindowTypeEnum = Object.freeze({
  CONFIGS: "configs",
  GERAL: "geral",
  PLATAFORMAS: "plataformas",
  WORKFLOW: "workflow"
});

export default {
  components: {
    ConfigWindow,
    GeneralWindow,
    PlataformWindow,
    WorkflowWindow
  },
  data() {
    return {
      tipos: [],
      currentTab: "geral"
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    tabs() {
      const configs = this.tipos.map(tipo => ({
        ...tipo,
        type: WindowTypeEnum.CONFIGS
      }));
      const tabs = [
        {
          id: "plataformas",
          nome: "Plataformas",
          type: WindowTypeEnum.PLATAFORMAS
        },
        // {
        //   id: "workflow",
        //   nome: "Workflow",
        //   type: WindowTypeEnum.WORKFLOW
        // }
      ];

      tabs.push(...configs);
      tabs.sort(({ nome: a }, { nome: b }) => a.localeCompare(b));
      tabs.unshift({
        id: "geral",
        nome: "Geral",
        type: WindowTypeEnum.GERAL
      });

      return tabs;
    },
    WindowTypeEnum() {
      return WindowTypeEnum;
    }
  },
  async created() {
    if (this.clientId === 0) {
      this.goToHome();
      return;
    }

    await this.getConfigTypes();
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    async changeTab(tipo) {
      this.currentTab = tipo;
    },
    async getConfigTypes() {
      try {
        const resource = this.apiResource(
          `v1/ativacaoped/${this.clientId}/configuracoes/tipos`
        );
        const tipos = await resource.get();
        this.tipos = tipos;
      } catch (error) {
        this.tipos = [];
        this.selectedType = "geral";

        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>

<template>
  <v-card class="form-container">
    <v-item-group v-model="currentTab" class="tab-container" mandatory :style="{ '--table-color': tableColor }">
      <v-item
        v-for="{ id, nome } in tabs"
        v-slot="{ active }"
        :value="id"
        :key="id"
      >
        <v-btn
          class="tab"
          :class="{ active }"
          dense
          text
          tile
          @click="changeTab(id)"
        >
          {{ nome }}
        </v-btn>
      </v-item>
    </v-item-group>

    <v-window v-model="currentTab" continuous>
      <v-window-item v-for="{ id, type } in tabs" :value="id" :key="id">
        <ConfigWindow v-if="type === WindowTypeEnum.CONFIGS" :typeId="id" />
        <GeneralWindow v-if="type === WindowTypeEnum.GERAL" />
        <PlataformWindow v-if="type === WindowTypeEnum.PLATAFORMAS" />
        <WorkflowWindow v-if="type === WindowTypeEnum.WORKFLOW" />
      </v-window-item>
    </v-window>
  </v-card>
</template>

<style lang="scss" scoped>
.form-container {
  height: calc(100% - 1rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tab-container + .v-window.v-item-group {
  overflow-y: hidden;
  flex-grow: 1;
  width: 100%;

  ::v-deep {
    .v-window__container {
      &,
      & .v-window-item {
        height: 100%;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
  width: auto;
}

.tab-container {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 0.75rem 0.75rem 0 0.75rem;
  text-align: center;
  transition: box-shadow 0.3s ease;
  z-index: 1;

  &.shadow-header {
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1),
      0 4px 5px 0 rgba(0, 0, 0, 0.07), 0 1px 10px 0 rgba(0, 0, 0, 0.06);
  }

  .tab {
    display: flex;
    opacity: 0.8;
    padding: 0 1rem;
    border-radius: 10px 10px 0 0;

    &.active {
      background-color: var(--table-color);
      opacity: 1;
    }
  }
}
</style>
